module.exports = __webpack_public_path__ + "img/share-fb.34d12305.svg";